import {
  AdmissionIcon,
  CollegePredictorIcon,
  EducationLoadIcon,
  PlacementIcon,
  ReviewsIcon,
  ScholarshipIcon,
  // RankingImage,
  FindCollegeImage,
  // CollegePredictorImage,
  // CompareCollegeImage,
  StudyAbroadImage,
  ExamsImage,
  GraduateSvg,
  MailSvg,
  UserSvg,
  PhoneSvg,
  LocationSvg,
  GlobeSvg,
  Profile,
} from "@/src/Asset";
import { generateNumberBasedOnId } from "@/utils/helpers/generateCount";
import Link from "next/link";

//   Lead form services data
export const services = [
  { name: "Admission", icon: AdmissionIcon, alt: "Admission service" },
  { name: "Placement", icon: PlacementIcon, alt: "Placement service" },
  { name: "Review", icon: ReviewsIcon, alt: "Review service" },
  {
    name: "Education Loan",
    icon: EducationLoadIcon,
    alt: "Education Loan service",
  },
  { name: "Scholarship", icon: ScholarshipIcon, alt: "Scholarship service" },
  {
    name: "College Predictor",
    icon: CollegePredictorIcon,
    alt: "College Predictor service",
  },
];

export const formFields = [
  {
    label: "Full Name",
    name: "name",
    icon: <UserSvg className="scale-75" />,
    placeholder: "Enter Full Name",
    type: "text",
  },
  {
    label: "Email Address",
    name: "email",
    icon: <MailSvg className="scale-75" />,
    placeholder: "Enter Email Address",
    type: "email",
  },
  {
    label: "Phone Number",
    name: "phone_number",
    icon: <PhoneSvg className="scale-75" />,
    placeholder: "Enter Phone Number",
    type: "tel",
  },
  {
    label: "City you live in",
    name: "city",
    icon: <LocationSvg className="scale-75" />,
    placeholder: "Enter City",
    type: "text",
  },
  {
    label: "Course",
    name: "course",
    icon: <GraduateSvg className="scale-75" />,
    placeholder: "Select course",
    type: "text",
  },
  {
    label: "Country Applying for",
    name: "country",
    icon: <GlobeSvg className="w-4" />,
    placeholder: "Select country",
    type: "array",
  },
];

export const reviewFormFields = [
  {
    label: "Full Name",
    name: "name",
    icon: <UserSvg className="scale-75" />,
    placeholder: "Enter Full Name",
    type: "text",
  },
  {
    label: "Email Address",
    name: "email",
    icon: <MailSvg className="scale-75" />,
    placeholder: "Enter Email Address",
    type: "email",
  },
  {
    label: "Phone Number",
    name: "phone_number",
    icon: <PhoneSvg className="scale-75" />,
    placeholder: "Enter Phone Number",
    type: "tel",
  },
  {
    label: "Country",
    name: "country",
    icon: <GlobeSvg className="w-4" />,
    placeholder: "Select country",
    type: "text",
  },
];

export const getCourseSpecialQueryParams = (
  type: "course" | "specialization",
  courseId: string | number
): Record<string, any> => {
  const commonPopulate = [
    { name: "icon", fields: ["id", "url", "name"] },
    { name: "streams", fields: ["id", "stream_name", "filter_sequence"] },
    { name: type === "course" ? "course_navbars" : "special_navbars" },
    { name: "banner", fields: ["name", "url", "id"] },
    { name: "logo", fields: ["name", "url", "id"] },
    {
      name: "news",
      populate: [
        {
          name: "featured_image",
          fields: ["name", "url"],
        },
      ],
    },
    {
      name: "blogs",
    },
    // {
    //   name: "gallery",
    // },
    {
      name: "page_data",
      populate: [
        {
          name: `${type === "course" ? "course" : "special"}.seo`,
          fields: [
            "body_all_html_content",
            "body_html_content",
            type === "course" ? "course_navbar" : "special_navbar",
            "head_all_html_content",
            "head_html_content",
            "favicon",
          ],
        },
        {
          name: `${type === "course" ? "course" : "special"}.overview`,
          fields: [type === "course" ? "course_navbar" : "special_navbar"],
        },
        {
          name: `${type === "course" ? "course" : "special"}.latest-update`,
          fields: [type === "course" ? "course_navbar" : "special_navbar"],
        },
        {
          name: `${type === "course" ? "course" : "special"}.faq`,
          fields: [
            type === "course" ? "course_navbar" : "special_navbar",
            "questions",
          ],
        },
        {
          name: `${
            type === "course" ? "course" : "special"
          }.recommended-colleges`,
          fields: [
            type === "course" ? "course_navbar" : "special_navbar",
            "colleges",
          ],
        },
        {
          name: `${
            type === "course" ? "course" : "special"
          }.recommended-courses`,
          fields: [
            type === "course" ? "course_navbar" : "special_navbar",
            "courses",
          ],
        },
        {
          name: `${type === "course" ? "course" : "special"}.rating-and-review`,
          fields: [type === "course" ? "course_navbar" : "special_navbar"],
        },
        {
          name: `${
            type === "course" ? "course" : "special"
          }.department-component`,
          fields: [
            type === "course" ? "course_navbar" : "special_navbar",
            "courses",
          ],
        },
        {
          name: `${type === "course" ? "course" : "special"}.banner`,
          fields: [type === "course" ? "course_navbar" : "special_navbar"],
        },
        {
          name: `${type === "course" ? "course" : "special"}.news-and-update`,
          fields: [type === "course" ? "course_navbar" : "special_navbar"],
        },
        {
          name: `${type === "course" ? "course" : "special"}.compare-component`,
          fields: [type === "course" ? "course_navbar" : "special_navbar"],
        },
        {
          name: `${type === "course" ? "course" : "special"}.recommended-exams`,
          fields: [
            type === "course" ? "course_navbar" : "special_navbar",
            "exams",
          ],
        },
        {
          name: `${
            type === "course" ? "course" : "special"
          }.recommended-countries`,
          fields: [
            type === "course" ? "course_navbar" : "special_navbar",
            "countries",
          ],
        },
        {
          name: `${
            type === "course" ? "course" : "special"
          }.recommended-scholar`,
          fields: [
            type === "course" ? "course_navbar" : "special_navbar",
            "scholarships",
          ],
        },
      ],
    },
  ];

  return {
    sort: "display_sequence:asc",
    filters: {
      [`${type === "course" ? "course_url" : "specialization_url"}`]: {
        $eq: courseId,
      },
    },
    populate: commonPopulate,
  };
};

export const getBoardQueryParams = (
  boardId: string | number
): Record<string, any> => {
  const commonPopulate = [
    {
      name: "articles",
      populate: [
        {
          name: "article_image",
          fields: ["name", "url"],
        },
      ],
    },
    {
      name: "news",
      populate: [
        {
          name: "featured_image",
          fields: ["name", "url"],
        },
        {
          name: "categories",
        },
      ],
    },
    {
      name: "page_data",
    },
    {
      name: "sample_paper",
    },
  ];

  return {
    sort: "createdAt:asc",
    filters: {
      board_url: {
        $eq: boardId,
      },
    },
    populate: commonPopulate,
  };
};

// Program Card Homepage
export const cardData = (course: any, courseData: any) => {
  return [
    {
      title: "Find Colleges",
      subHeading: "Discover 15000+ colleges via preferences",
      imageSrc: FindCollegeImage,
      linkText: `Explore Top ${course?.abbreviation} Colleges in India`,
      linkUrl: `${course?.course_url
        ?.replace(/\s+/g, "-")
        .toLowerCase()}-colleges-in-india`,
      content: (
        <div className="text-left text-xs mt-1">
          <ul className="flex flex-wrap gap-y-1.5 justify-between">
            {courseData?.cities &&
              courseData?.cities?.length > 0 &&
              courseData?.cities?.slice(0, 6)?.map((city: any) => {
                const courseUrl = course?.course_url
                  ?.replace(/\s+/g, "-")
                  ?.toLowerCase();
                const cityUrl = city?.city_url
                  ?.replace(/\s+/g, "-")
                  ?.toLowerCase();

                return (
                  <li key={city?.id} className="capitalize">
                    <Link
                      href={`/${courseUrl}-colleges-in-${cityUrl}`}
                      className="bg-primary-white p-1 rounded-full px-2 py-0.5"
                    >
                      Top {course?.abbreviation} colleges in {city?.city_name}
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>
      ),
    },
    {
      title: "Exams",
      subHeading: "Know more about your exams",
      imageSrc: ExamsImage,
      linkText: `Check all ${
        courseData?.abbreviation || "available"
      } exams in India`,
      linkUrl: `/exams/${courseData?.streams?.[0]?.stream_name
        ?.replace(/\s+/g, "-")
        ?.toLowerCase()}`,
      content: (
        <div className="flex flex-wrap gap-x-2 gap-y-1.5 text-center">
          {courseData?.exams && courseData?.exams?.length > 0 ? (
            courseData?.exams?.slice(0, 10)?.map((exam: any) => {
              const examNavbar =
                exam?.exam_navbars?.[0]?.title
                  ?.replace(/\s+/g, "-")
                  ?.toLowerCase() || "exam-info";
              return (
                <Link
                  href={`/exams/${exam?.exam_url}/${examNavbar}`}
                  key={exam?.id}
                >
                  <p className="text-start bg-primary-white w-fit px-2 py-0.5 rounded-full text-xs">
                    {exam?.abbreviation || exam?.exam_name}
                  </p>
                </Link>
              );
            })
          ) : (
            <p className="text-center text-gray-500 text-xs">
              No exam is available for the related course.
            </p>
          )}
        </div>
      ),
    },
    {
      title: "Study Abroad",
      subHeading: "Discover colleges across the globe",
      imageSrc: StudyAbroadImage,
      linkText: "Study Abroad",
      linkUrl: "/study-abroad",
      content: (
        <div className="flex flex-wrap gap-2 text-center capitalize text-xs mt-1">
          {courseData?.countries &&
            courseData?.countries?.length > 0 &&
            courseData?.countries
              ?.filter(
                (country: any) =>
                  country?.country_name?.toLowerCase() !== "india"
              ) // Filter out India
              ?.slice(0, 15)
              ?.map((country: any) => {
                const courseUrl = course?.course_url
                  ?.replace(/\s+/g, "-")
                  ?.toLowerCase();

                const countryUrl = country?.country_url?.includes("study-in-")
                  ? country.country_url
                      .replace("study-in-", "colleges-in-")
                      .replace(/\s+/g, "-")
                      .toLowerCase()
                  : "#";

                return (
                  <Link
                    href={
                      countryUrl !== "#" ? `/${courseUrl}-${countryUrl}` : "#"
                    }
                    key={country?.id}
                    className="text-start bg-primary-white w-fit px-2 py-0.5 rounded-full text-xs"
                  >
                    {country?.abbreviation || country?.country_name}
                  </Link>
                );
              })}
        </div>
      ),
    },
  ];
};

export const targetCountries = [
  { id: 1, country_name: "UNITED KINGDOM", left: 38, right: 12 },
  { id: 2, country_name: "UNITED STATES", left: 10, right: 20 },
  { id: 3, country_name: "UNITED ARAB EMIRATES", left: 52, right: 30 },
  { id: 4, country_name: "UZBEKISTAN", left: 56, right: 16 },
  { id: 5, country_name: "KAZAKHSTAN", left: 58, right: 10 },
  { id: 6, country_name: "CANADA", left: 14, right: 8 },
  { id: 7, country_name: "AUSTRALIA", left: 85, right: 65 },
  { id: 8, country_name: "GERMANY", left: 38, right: 35 },
  { id: 9, country_name: "IRELAND", left: 35, right: 19 },
  { id: 10, country_name: "NEW ZEALAND", left: 91, right: 80 },
  { id: 11, country_name: "NETHERLANDS", left: 41, right: 25 },
  { id: 12, country_name: "SINGAPORE", left: 75, right: 53 },
  { id: 13, country_name: "SWITZERLAND", left: 45, right: 40 },
];

function formatCost(value: number) {
  const yearlyValue = value * 12;

  if (yearlyValue >= 1000) {
    return `${(yearlyValue / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  }
  return yearlyValue.toString();
}

export const StudyAbroadCountData = (country: any) => [
  {
    id: 1,
    label: "Exams",
    value: `${country?.exams?.count > 0 ? country?.exams?.count : generateNumberBasedOnId(country?.id, 30, 50)}+`,
    icon: Profile,
  },
  {
    id: 2,
    label: "Scholarships",
    value: `${country?.scholarships?.count > 0 ? country?.scholarships?.count : generateNumberBasedOnId(country?.id, 30, 50)  }+`,
    icon: Profile,
  },
  {
    id: 3,
    label: "Avg. Living Costs",
    value: `${
      country?.average_cost_living
        ? formatCost(country?.average_cost_living)
        : "N/A"
    } USD/yr`,
    icon: Profile,
  },
  {
    id: 4,
    label: "Courses",
    value: `${country?.courses?.count > 0 ? country?.courses?.count : generateNumberBasedOnId(country?.id, 30, 50)}+`,
    icon: Profile,
  },
];

export const linksData = (country: any) => [
  {
    id: 1,
    label: `Why Choose ${country?.country_name}`,
    url: "#why-choose-usa",
  },
  { id: 2, label: "SOP/LOR Guidance", url: "#sop-lor-guidance" },
  {
    id: 3,
    label: `Careers After Studying ${country?.country_name}`,
    url: "#careers-after-usa",
  },
  // { id: 4, label: "Sample Paper & More", url: "#sample-paper-more" },
];
